module.exports = __webpack_public_path__ + "img/login-logo.4671a86e.svg";